import { render } from "./RecipientInfo.vue?vue&type=template&id=b381265a&scoped=true&ts=true"
import script from "./RecipientInfo.vue?vue&type=script&lang=ts"
export * from "./RecipientInfo.vue?vue&type=script&lang=ts"

import "./RecipientInfo.vue?vue&type=style&index=0&id=b381265a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b381265a"]])

export default __exports__